import { ExternalLink } from "@mcleod/core";
import { Component, Label, LabelProps } from "@mcleod/components";

export class PageHeaderProvider {
    public static get(): PageHeaderProvider {
        if (_singleton == null)
            _singleton = new PageHeaderProvider();
        return _singleton;
    }

    public static set(provider: PageHeaderProvider) {
        _singleton = provider;
    }

    /**
     * Returns an array containing components that should be displayed to the user in the current web application.
     */
    public async getAppSpecificComponents(): Promise<Component[]> {
        return [];
    }

    public shouldDisplayUserSettings(): boolean {
        return true;
    }

    getUserDropdownMenuItems(sharedProps: Partial<LabelProps>): Label[] {
        const result: Label[] = [];
        return result;
    }

    public shouldDisplayHelpLinks(): boolean {
        return false;
    }

    public getAddlExternalLinks(): ExternalLink[] {
        return [];
    }
}

let _singleton: PageHeaderProvider;
